import SectionLoyaltyTestInfo from './SectionLoyaltyTestInfo';

export default SectionLoyaltyTestInfo; 